export const GOOGLE_MAPS_KEY = import.meta.env.MIX_GOOGLE_MAPS_API_KEY as string
export const GOOGLE_MAPS_ID = import.meta.env.MIX_GOOGLE_MAPS_ID as string
